import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setIabpFrequencyOptions } from '../store/options.actions'

export function* getIabpFrequencyOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const iabpFrequencyOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getIabpFrequencyOptions,
    ])
    const { entity } = iabpFrequencyOptionsResponse
    if (entity) yield put(setIabpFrequencyOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getIabpFrequencyOptions() error: ${e}`))
  }
}

export function* getIabpFrequencyOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getIabpFrequencyOptions)
}
